import { Button, Card, Image, message, Popconfirm, Space } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import AddJobUpdate from "./AddJobUpdate";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

function JobUpdateTable() {
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteResponse, deleteRequest] = useApi();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const columns = [
    {
      title: "Text",
      dataIndex: "text",
    },
    {
      title: "Image",
      dataIndex: "image",
      render: (text, record) => <Image src={text} width={100} />,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title="Delete Job Update"
                description={`Are you sure to delete this job update?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/job-updates?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();

      messageApi.open({
        type: "success",
        content: "Job Update Deleted successfully",
      });
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  const handleAddJobUpdate = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditJobUpdate = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/admin/job-updates/${record.id}`);
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/job-updates?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Job Updates"
      extra={
        <Button type="default" onClick={handleAddJobUpdate}>
          Add Job Update
        </Button>
      }
    >
      {contextHolder}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visible && <AddJobUpdate visible={visible} close={handleAddJobUpdate} />}
      {visibleEdit && (
        <AddJobUpdate
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditJobUpdate}
        />
      )}
    </Card>
  );
}

export default JobUpdateTable;
